import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { CpfField } from '../../components/Fields'
import { connect } from 'react-redux'
import { userActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '340px'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = user => {
    const { onClose, addUser, editUser, changeMessage } = this.props
    if (user._id) {
      editUser(user).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addUser(user).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }
  componentDidMount() {
    const { fetchProfiles } = this.props
    fetchProfiles()
  }
  handleSubmit = (e, user) => {
    e.preventDefault()
    const { setUserFormTouched } = this.props

    if (this.props.userFormErrors.valid) {
      this.handleSave(user)
    } else {
      setUserFormTouched()
    }
    return false
  }
  clearErrors = () => {
    this.setState({ formErrors: {} })
  }
  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      user,
      handleChangeUser,
      loadingUser,
      userFormErrors,
      formTouched,
      profiles,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this

    const isReadOnly = readOnly('usuarios', token)

    return (
      <div>
        <Dialog
          modalId={user._id ? 'usuarios-editar' : 'usuarios-novo'}
          modalParams={{ registro: user._id }}
          fullScreen={fullScreen}
          open={open}
          onClose={onClose}
        >
          {loadingUser ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(user._id ? 'usuarios-editar' : 'usuarios-novo') + '-title'}>
                {isReadOnly ? (
                  'Usuário'
                ) : (
                  <Fragment>{user._id ? 'Editar usuário' : 'Cadastrar usuário'}</Fragment>
                )}
              </DialogTitle>
              <DialogContent>
                <form
                  id={'user-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, user)
                  }}
                >
                  <FormControl
                    error={!((userFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome completo</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeUser({ ...user, nome: e.target.value })
                      }}
                      value={user.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((userFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((userFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Perfil de acesso</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={!((userFormErrors.fields || {})['perfil'] || {}).valid && formTouched}
                      onChange={e => {
                        clearErrors()
                        handleChangeUser({
                          ...user,
                          perfil: { _id: e.target.value }
                        })
                      }}
                      value={user.perfil._id || ''}
                    >
                      {(profiles || []).map(profile => {
                        return (
                          <MenuItem key={profile._id} value={profile._id}>
                            {profile.nome}
                          </MenuItem>
                        )
                      })}
                    </Select>
                    {!((userFormErrors.fields || {})['perfil'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((userFormErrors.fields || {})['perfil'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={!((userFormErrors.fields || {})['cpf'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-cpf">CPF</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      inputComponent={CpfField}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeUser({ ...user, cpf: e.target.value })
                      }}
                      value={user.cpf || ''}
                      id="field-cpf"
                    />
                    {!((userFormErrors.fields || {})['cpf'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((userFormErrors.fields || {})['cpf'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={!((userFormErrors.fields || {})['email'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-email">E-mail</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      value={user.email}
                      onChange={e => {
                        clearErrors()
                        handleChangeUser({ ...user, email: e.target.value })
                      }}
                      type="email"
                      id="field-email"
                    />
                    {!((userFormErrors.fields || {})['email'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((userFormErrors.fields || {})['email'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'user-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    loadingUser: state.user.loadingUser,
    userFormErrors: state.user.userFormErrors,
    formTouched: state.user.userFormTouched,
    profiles: state.user.profiles,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(userActions.openModal())
    },
    closeModal: () => {
      dispatch(userActions.closeModal())
    },
    handleChangeUser: user => {
      dispatch(userActions.handleChangeUser(user))
    },
    addUser: user => {
      return dispatch(userActions.addUser(user))
    },
    editUser: user => {
      return dispatch(userActions.editUser(user))
    },
    setUserFormTouched: user => {
      dispatch(userActions.setUserFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchProfiles: () => {
      dispatch(userActions.fetchProfiles())
    },
    fetchUsers: ({ page, perPage }) => {
      dispatch(userActions.fetchUsers({ page, perPage }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Users/EditModal.js